import React from "react";
import TextField from '@mui/material/TextField';
import { COLOR_MAP } from "../../constants/ColorNames";
import { ClickAwayListener, IconButton, InputAdornment, SxProps, Theme, Tooltip } from "@mui/material";
import { INFO_ICON } from "../../constants/icons/InfoIcon";


type TextFieldProps = {
    placeholder?: string,
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    id: string,
    textValue?: string,
    disabled?: boolean,
    isRequired?: boolean,
    showError?:boolean,
    errorMessage?: string,
    inputProps?: any,
    onKeyDown? : (e: any) => void;
    onClickAway? : () => void;
    sx? : SxProps<Theme> | undefined;
    icon?:boolean
}

const RenderAdornment = () => {
    const iconRef = React.useRef<any>(null);
    return (
        <InputAdornment position="end">
            <Tooltip
                placement="top-start"
                title={
                    <div style={{fontSize:'14px', display: 'inline-block' }}>
                        Personal mail ID cannot be used to send blast campaigns.
                    </div>
                }
               
                arrow
                componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: '#6d6d6d',
                        padding:'10px',
                        color: '#fff',
                        fontSize:'14px',
                        maxWidth:'310px',
                      },
                    },
                    arrow:{
                        sx: {
                            color: '#6d6d6d !important',
                        }
                    }
                  }}
                PopperProps={{
                    popperOptions: {
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: () => {
                                        if (iconRef.current) {
                                            const inputWidth = iconRef.current.closest('div.MuiInputBase-root')?.offsetWidth || 0;
                                            const iconWidth = iconRef.current.offsetWidth;
                                            return [-(inputWidth - iconWidth - 14), -2]; 
                                        }
                                        return [0, -2];
                                    },
                                },
                            }
                        ],
                    },
                }}
            >
                <IconButton aria-label="information" ref={iconRef}>
                    <INFO_ICON/>
                </IconButton>
            </Tooltip>
        </InputAdornment>
    );
};

const TextBox = (props: TextFieldProps) => {
    const {
        placeholder,
        handleChange,
        id,
        textValue = '',
        isRequired = true,
        disabled, 
        showError,
        errorMessage,
        inputProps,
        onKeyDown,
        onClickAway = () => {},
        sx,
        icon
    } = props

    return (
      <ClickAwayListener onClickAway={onClickAway}>
        <TextField
            disabled={disabled}
            value={textValue}
            id={id}
            hiddenLabel
            onChange={handleChange}
            variant="outlined"
            placeholder={placeholder}
            sx={{
                backgroundColor: disabled ? COLOR_MAP.DISABLED : COLOR_MAP.WHITE,
                color: disabled ? COLOR_MAP.GREY_1 : COLOR_MAP.LIGHT_GREY,
                ...sx
            }}
            error={showError}
            helperText={errorMessage}
            InputProps={icon ? {...inputProps,
                endAdornment:(
                    RenderAdornment()
                )
            }: inputProps}
            onKeyDown={onKeyDown}
        />
        </ClickAwayListener>
    )

}

export default TextBox;

